(function () {
  const scrollTop = () => {
    const btnScrollTop = document.querySelector('.scroll-top');
    const footer = document.querySelector('.shopify-section-group-footer-group');
    const addToCartButtonIds = [
      '#ProductSubmitButton-template--17156699685052__main',
      '#ProductSubmitButton-template--17133232980156__main',
      '#ProductSubmitButton-template--17133950927036__main'
    ];
    const isProductPage = document.body.classList.contains('template-product');

    if (!isProductPage || !btnScrollTop) return;

    const getAddToCartButton = () => {
      for (let id of addToCartButtonIds) {
        const button = document.querySelector(id);
        if (button) return button;
      }
      return null;
    };

    window.addEventListener('scroll', function () {
      const addToCartButton = getAddToCartButton();
      if (footer && addToCartButton) {
        const scrollPosition = window.scrollY + window.innerHeight;
        const footerPosition = footer.offsetTop;
        const addToCartPosition = addToCartButton.getBoundingClientRect().bottom;
        const isDesktop = window.innerWidth >= 768;

        if (scrollY > document.documentElement.clientHeight) {
          if (scrollPosition > footerPosition) {
            btnScrollTop.classList.remove('show');
            btnScrollTop.classList.add('hidden');
          } else if (isDesktop && addToCartPosition > 0) {
            btnScrollTop.classList.remove('show');
            btnScrollTop.classList.add('hidden');
          } else {
            btnScrollTop.classList.add('show');
            btnScrollTop.classList.remove('hidden');
          }
        } else {
          btnScrollTop.classList.remove('show');
          btnScrollTop.classList.add('hidden');
        }
      }
    });

    btnScrollTop.onclick = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }

  scrollTop();
  document.addEventListener("shopify:section:load", function () {
    scrollTop();
  })
})()